import { useSelector } from 'react-redux';
import { showLoaderSelector } from '../selectors/cluster.selectors';
import { BaseClustersContainer } from './baseClusters/BaseClustersContainer';
import { LoadingMerging } from './loadingComponents/LoadingMerging';
import { MorphologiesContainer } from './morphology/MorphologiesContainer';
import { NavigateNextButton } from './Navigation/NavigateNextButton';

export const Merging: React.FC = () => {
  const showLoader = useSelector(showLoaderSelector);

  if (showLoader) {
    return <LoadingMerging />;
  }

  return (
    <>
      <NavigateNextButton />
      <BaseClustersContainer />
      <MorphologiesContainer />
    </>
  );
};
